// Amalgamate all subsection form field enums
import { OverviewFormField } from './subsections/overview/formField'

export const ResumptionOverviewFormField = {
  ...OverviewFormField
} as const

export type ResumptionOverviewFormField =
  (typeof ResumptionOverviewFormField)[keyof typeof ResumptionOverviewFormField]
